import React from 'react';
import { AppSkeleton } from '@/components/base/Skeleton';

interface AppLoaderProps {
  /** Retained for call-site compatibility; the skeleton renders no copy. */
  message?: string;
}

/**
 * Boot-time loader for the whole admin shell. Renders the skeleton of the shell
 * it is about to replace (sidebar, header, content) rather than a branded
 * spinner, so the first paint already has the shape of the app.
 */
const AppLoader: React.FC<AppLoaderProps> = () => (
  <div className="fixed inset-0 z-50 bg-white dark:bg-slate-900">
    <AppSkeleton />
  </div>
);

export default AppLoader;
